function loadEmailJS() {
  return new Promise(resolve => {
    const ejsScript = document.createElement('script');
    ejsScript.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
    ejsScript.onload = resolve;
    document.head.appendChild(ejsScript);
  });
}

// ============================================================
// diagnostic-ui.js — version complète
// ============================================================

const DiagnosticUI = {
  answers:      {},
  currentStep:  0,
  container:    null,
  isSubmitting: false
}

const _variantCache = {}

function renderIntro(onStart) {
  const wrapper = document.createElement('div')
  wrapper.className = 'diag-intro-page'

  wrapper.innerHTML = `
    <h1 class="diag-intro-titre">Votre diagnostic de peau personnalisé</h1>

    <p class="diag-intro-texte">
      Répondez à quelques questions sur votre peau et vos habitudes de vie.
      À partir de vos réponses, nous évaluerons les cinq grandes fonctions de votre peau
      afin d'identifier ses principaux besoins.
    </p>

    <p class="diag-intro-cards-titre">À l'issue du diagnostic, vous recevrez :</p>

    <div class="diag-intro-cards">
      <div class="diag-intro-card">
       <div class="diag-intro-card__label">Votre profil cutané</div>
       <div class="diag-intro-card__desc">Une analyse personnalisée des cinq grandes fonctions de votre peau.</div>
      </div>

      <div class="diag-intro-card">
        <div class="diag-intro-card__label">L'interprétation de vos résultats</div>
        <div class="diag-intro-card__desc">Comprenez ce que révèlent vos réponses.</div>
      </div>

      <div class="diag-intro-card">
        <div class="diag-intro-card__label">Des conseils personnalisés</div>
        <div class="diag-intro-card__desc">Pour accompagner votre peau au quotidien.</div>
      </div>

      <div class="diag-intro-card">
       <div class="diag-intro-card__label">Votre routine adaptée</div>
       <div class="diag-intro-card__desc">Des recommandations cohérentes avec votre profil.</div>
      </div>
    </div>

    <p class="diag-intro-meta">
     Environ 3 à 5 minutes &nbsp;•&nbsp; 10 questions &nbsp;•&nbsp; Plusieurs réponses possibles
    </p>

    <div class="diag-intro-prenom">
      <label class="diag-intro-prenom__label" for="diag-prenom">
       Quel est votre prénom ?
      </label>

      <input
        class="diag-intro-prenom__input"
        type="text"
        id="diag-prenom"
        placeholder="Facultatif"
        autocomplete="given-name"
      />

      <p class="diag-intro-prenom__hint">
        Il sera utilisé pour personnaliser votre diagnostic et identifier ce profil
        si vous choisissez de l'enregistrer dans votre espace personnel.
      </p>
    </div>

    <button class="diag-btn diag-btn--primary diag-intro-cta">
     Commencer le diagnostic
    </button>

    <div class="diag-intro-privacy">
      <p>Vos réponses restent confidentielles.</p>
      <p>La création d'un compte et l'enregistrement de votre diagnostic sont entièrement facultatifs.</p>
    </div>

    <div class="diag-intro-account">
      <div class="diag-intro-account__title">
        Avec votre compte Kosmorebi
      </div>

      <ul class="diag-intro-account__list">
        <li>Retrouvez vos diagnostics depuis votre espace client.</li>
        <li>Enregistrez plusieurs profils (vous, votre conjoint, vos enfants...).</li>
        <li>Mettez à jour chaque profil en refaisant le diagnostic lorsque vous le souhaitez.</li>
      </ul>
    </div>
`

  wrapper.querySelector('.diag-intro-cta').addEventListener('click', () => {
    const input = wrapper.querySelector('#diag-prenom')
    window.diagPrenom = (input && input.value.trim()) ? input.value.trim() : null
    onStart()
  })

  return wrapper
}

// ------------------------------------------------------------
// QUESTIONS ACTIVES (conditionnelles)
// ------------------------------------------------------------

function getActiveQuestions() {
  return QUESTIONS.filter(q => estQuestionActive(q, DiagnosticUI.answers))
}

// ------------------------------------------------------------
// INIT
// ------------------------------------------------------------

function initDiagnostic(containerId) {
  DiagnosticUI.container = document.getElementById(containerId)
  if (!DiagnosticUI.container) {
    console.error('[diagnostic-ui] Conteneur introuvable :', containerId)
    return
  }
  const profilSauvegarde = sessionStorage.getItem(
  'kosmorebi_profil_a_revoir'
)

if (profilSauvegarde) {
  try {
    const profil = JSON.parse(profilSauvegarde)

    sessionStorage.removeItem('kosmorebi_profil_a_revoir')

    window.diagPrenom =
      profil.nom && profil.nom !== 'Mon profil'
        ? profil.nom
        : null

    if (profil.content) {
      renderResults(profil.content)
      return
    }
  } catch (error) {
    console.error(
      '[diagnostic-ui] Impossible de réafficher le profil :',
      error
    )

    sessionStorage.removeItem('kosmorebi_profil_a_revoir')
  }
}
  DiagnosticUI.answers     = {}
  DiagnosticUI.currentStep = 0

  // Lecture des résultats depuis l'URL
  const params = new URLSearchParams(window.location.search)
  const encodedResult = params.get('r')
  if (encodedResult) {
    try {
      const content = JSON.parse(decodeURIComponent(escape(atob(encodedResult))))
      renderResults(content)
      return
    } catch(e) {
      console.warn('Résultats invalides dans l\'URL', e)
    }
  }

  DiagnosticUI.container.innerHTML = ''
  DiagnosticUI.container.appendChild(renderIntro(() => {
    DiagnosticUI.container.innerHTML = ''
    renderStep(0)
  }))
}

// ------------------------------------------------------------
// ÉTAPES
// ------------------------------------------------------------

function renderStep(index) {
  const activeQuestions = getActiveQuestions()
  const question = activeQuestions[index]
  if (!question) return

  const container = DiagnosticUI.container
  container.innerHTML = ''

  if (index === 0 && window.diagPrenom) {
    const bienvenue = document.createElement('p')
    bienvenue.className   = 'diag-bienvenue'
    bienvenue.textContent = `Bienvenue ${window.diagPrenom}`
    container.appendChild(bienvenue)
  }

  container.appendChild(renderProgressBar(index, activeQuestions.length))

  const card = document.createElement('div')
  card.className = 'diag-card'

  const label = document.createElement('h2')
  label.className   = 'diag-question-label'
  label.textContent = question.label
  card.appendChild(label)

  if (question.instruction) {
    const instruction = document.createElement('p')
    instruction.className   = 'diag-question-instruction'
    instruction.textContent = question.instruction
    card.appendChild(instruction)
  }

  card.appendChild(renderOptions(question))
  card.appendChild(renderNavigation(index, activeQuestions.length))
  container.appendChild(card)
  applyMaxSelectionsState(question.id)
}

function renderProgressBar(index, total) {
  const wrapper = document.createElement('div')
  wrapper.className = 'diag-progress'
  const bar = document.createElement('div')
  bar.className = 'diag-progress-bar'
  const fill = document.createElement('div')
  fill.className   = 'diag-progress-fill'
  fill.style.width = `${Math.round((index / total) * 100)}%`
  bar.appendChild(fill)
  wrapper.appendChild(bar)
  const label = document.createElement('span')
  label.className   = 'diag-progress-label'
  label.textContent = `Question ${index + 1} sur ${total}`
  wrapper.appendChild(label)
  return wrapper
}

function renderOptions(question) {
  const wrapper = document.createElement('div')
  wrapper.className        = 'diag-options'
  wrapper.dataset.question = question.id
  question.options.forEach(option => {
    const item = document.createElement('label')
    item.className        = 'diag-option'
    item.dataset.option   = option.id
    item.dataset.question = question.id
    const input = document.createElement('input')
    input.type    = question.type === 'radio' ? 'radio' : 'checkbox'
    input.name    = question.id
    input.value   = option.id
    input.checked = getSelectedAnswers(question.id).includes(option.id)
    input.addEventListener('change', () => {
      handleOptionChange(question.id, option.id, input.checked, question.type)
    })
    const span = document.createElement('span')
    span.textContent = option.label
    item.appendChild(input)
    item.appendChild(span)
    wrapper.appendChild(item)
  })
  return wrapper
}

function renderNavigation(index, total) {
  const nav = document.createElement('div')
  nav.className = 'diag-nav'
  if (index > 0) {
    const btnPrev = document.createElement('button')
    btnPrev.className   = 'diag-btn diag-btn--secondary'
    btnPrev.textContent = 'Précédent'
    btnPrev.addEventListener('click', () => goToPrev())
    nav.appendChild(btnPrev)
  }
  const btnNext = document.createElement('button')
  btnNext.className   = 'diag-btn diag-btn--primary'
  btnNext.textContent = index < total - 1 ? 'Suivant' : 'Voir mon diagnostic'
  btnNext.addEventListener('click', () => {
  if (index < total - 1) {
    goToNext()
  } else {
    submitDiagnostic()
  }
})
  nav.appendChild(btnNext)
  return nav
}

// ------------------------------------------------------------
// NAVIGATION
// ------------------------------------------------------------

function goToNext() {
  const activeQuestions = getActiveQuestions()
  const question = activeQuestions[DiagnosticUI.currentStep]
  const reponses = getSelectedAnswers(question.id)
  if (reponses.length === 0 && (question.type !== 'checkbox' || question.required)) {
    afficherErreur('Merci de sélectionner au moins une réponse.')
    return
  }
  DiagnosticUI.currentStep++
  renderStep(DiagnosticUI.currentStep)
  scrollToTop()
}

function goToPrev() {
  if (DiagnosticUI.currentStep > 0) {
    DiagnosticUI.currentStep--
    renderStep(DiagnosticUI.currentStep)
    scrollToTop()
  }
}

function scrollToTop() {
  DiagnosticUI.container?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

// ------------------------------------------------------------
// GESTION DES RÉPONSES
// ------------------------------------------------------------

function handleOptionChange(questionId, optionId, checked, type) {
  const question = QUESTIONS.find(q => q.id === questionId)
  if (!question) return
  const option = question.options.find(o => o.id === optionId)
  if (!option) return

  if (type === 'radio') {
    DiagnosticUI.answers[questionId] = optionId
    return
  }

  let selected = getSelectedAnswers(questionId)

  if (checked) {
    if (option.exclusive) {
      DiagnosticUI.answers[questionId] = [optionId]
      refreshOptions(questionId)
      applyMaxSelectionsState(questionId)
      return
    }
    selected = selected.filter(id => {
      const o = question.options.find(op => op.id === id)
      return o && !o.exclusive
    })
    if (question.maxSelections && selected.length >= question.maxSelections) {
      const input = document.querySelector(
        `[data-question="${questionId}"][data-option="${optionId}"] input`
      )
      if (input) input.checked = false
      return
    }
    selected.push(optionId)
  } else {
    selected = selected.filter(id => id !== optionId)
  }

  DiagnosticUI.answers[questionId] = selected
  applyMaxSelectionsState(questionId)
}

function applyMaxSelectionsState(questionId) {
  const question = QUESTIONS.find(q => q.id === questionId)
  if (!question || !question.maxSelections) return
  const selected      = getSelectedAnswers(questionId)
  const limitAtteinte = selected.length >= question.maxSelections
  question.options.forEach(option => {
    const labelEl = document.querySelector(
      `.diag-options[data-question="${questionId}"] [data-option="${option.id}"]`
    )
    const input = labelEl?.querySelector('input')
    if (!input) return
    const estCochee = selected.includes(option.id)
    input.disabled  = limitAtteinte && !estCochee && !option.exclusive
    if (labelEl) labelEl.classList.toggle('diag-option--disabled', input.disabled)
  })
}

function refreshOptions(questionId) {
  const selected = getSelectedAnswers(questionId)
  document.querySelectorAll(
    `.diag-options[data-question="${questionId}"] input`
  ).forEach(input => {
    input.checked = selected.includes(input.value)
  })
}

// ------------------------------------------------------------
// SOUMISSION
// ------------------------------------------------------------

function submitDiagnostic() {
  if (DiagnosticUI.isSubmitting) return
  DiagnosticUI.isSubmitting = true
  try {
    const result = runDiagnostic(DiagnosticUI.answers)
    const content = buildDiagnosticContent(result)

    window.__lastDiagResult = {
      ...result,
      content
    }

    // Sauvegarde du profil (multi-profils familiaux)
    const prenom = window.diagPrenom || 'Moi'
    const profils = JSON.parse(localStorage.getItem('kosmorebi_profils') || '{}')
    profils[prenom] = {
      content: { ...content, notes: result.notes },
      date: new Date().toISOString()
    }
    localStorage.setItem('kosmorebi_profils', JSON.stringify(profils))
    localStorage.setItem('kosmorebi_profil_actif', prenom)


    renderResults(content)
    loadProductImages()

  } catch (e) {
    console.error('[diagnostic-ui] Erreur :', e)
    showError('Une erreur est survenue. Merci de réessayer.')
    DiagnosticUI.isSubmitting = false
  }
}

// ------------------------------------------------------------
// RÉSULTATS
// ------------------------------------------------------------
const DIAGNOSTIC_SESSION_KEY = 'kosmorebi_diagnostic_session'

function sauvegarderDiagnosticEnCours(content) {
  try {
    sessionStorage.setItem(
      DIAGNOSTIC_SESSION_KEY,
      JSON.stringify({
        content,
        result: window.__lastDiagResult || null,
        prenom: window.diagPrenom || '',
        savedAt: Date.now()
      })
    )
  } catch (error) {
    console.warn(
      '[diagnostic-ui] Impossible de conserver le diagnostic :',
      error
    )
  }
}

function restaurerDiagnosticEnCours() {
  try {
    const raw = sessionStorage.getItem(DIAGNOSTIC_SESSION_KEY)

    if (!raw) return false

    const sauvegarde = JSON.parse(raw)

    if (!sauvegarde?.content) return false

    if (sauvegarde.prenom) {
      window.diagPrenom = sauvegarde.prenom
    }

    window.__lastDiagResult =
      sauvegarde.result || {
        content: sauvegarde.content
      }

    renderResults(sauvegarde.content)

    if (typeof loadProductImages === 'function') {
      loadProductImages()
    }

    return true
  } catch (error) {
    console.warn(
      '[diagnostic-ui] Impossible de restaurer le diagnostic :',
      error
    )

    return false
  }
}

function renderResults(content) {
  const container = DiagnosticUI.container
  container.innerHTML = ''

  sauvegarderDiagnosticEnCours(content)

  const intro = document.createElement('p')
  intro.className = 'diag-intro'
  const prenom = window.diagPrenom
  if (prenom) {
    intro.innerHTML = `<strong>${prenom}</strong>, ${content.introduction}`
  } else {
    intro.textContent = content.introduction
  }
  container.appendChild(intro)

  // --- SECTION 1 : Profil cutané (vert) ---
  const sectionProfil = document.createElement('div')
  sectionProfil.className = 'diag-section--profil'
  const titreObserve = document.createElement('h2')
  titreObserve.className   = 'diag-section-titre'
  titreObserve.textContent = 'Ce que nous avons observé'
  sectionProfil.appendChild(titreObserve)
  const introObserve = document.createElement('p')
  introObserve.className = 'diag-section-intro'
  introObserve.textContent = 'Ces résultats sont établis à partir de vos réponses au questionnaire Kosmorebi.'
  sectionProfil.appendChild(introObserve)
  sectionProfil.appendChild(renderRadar(content.piliers))
  const piliersGrid = document.createElement('div')
  piliersGrid.className = 'diag-piliers'
  content.piliers.forEach(pilier => {
    const el = document.createElement('div')
    el.className = `diag-pilier diag-pilier--${pilier.niveau}`
    el.innerHTML = `
      <div class="diag-pilier__top">
         <span class="diag-pilier__label">${pilier.label}</span>
         <span class="diag-pilier__score">${pilier.score}</span>
      </div>
      <p class="diag-pilier__message">${pilier.message}</p>


    `
    piliersGrid.appendChild(el)
  })
  sectionProfil.appendChild(piliersGrid)
  container.appendChild(sectionProfil)

  // --- SECTION 2 : Interprétation (rose) ---
  const sectionInterpretation = document.createElement('div')
  sectionInterpretation.className = 'diag-section--interpretation'
  const titreSynthese = document.createElement('h2')
  titreSynthese.className   = 'diag-section-titre'
  titreSynthese.textContent = 'Ce que cela signifie pour vous'
  sectionInterpretation.appendChild(titreSynthese)
  const synthese = document.createElement('p')
  synthese.className   = 'diag-synthese'
  synthese.textContent = content.synthese
  sectionInterpretation.appendChild(synthese)
  container.appendChild(sectionInterpretation)

  // --- SECTION 3 : Conseils personnalisés (bleu) ---
  const sectionConseils = document.createElement('div')
  sectionConseils.className = 'diag-section--conseils'
  const titreConseils = document.createElement('h2')
  titreConseils.className   = 'diag-section-titre'
  titreConseils.textContent = 'Quelques conseils pour votre peau'

  let notesApres = []
  if (content.notes && content.notes.length > 0) {
    const notesAvant = content.notes.filter(n => n.position !== 'apres')
    notesAvant.sort((a, b) => (b.priorite || 0) - (a.priorite || 0))
    notesApres = content.notes.filter(n => n.position === 'apres')
    if (notesAvant.length > 0) {
      sectionConseils.appendChild(titreConseils)
      const notesListe = document.createElement('div')
      notesListe.className = 'diag-notes'
      notesAvant.forEach((note, index) => {
        const li = document.createElement('div')
        li.className = 'diag-note'
        const memeTitre = index > 0 && notesAvant[index - 1].titre === note.titre
        li.innerHTML = `<strong class="diag-note-titre${memeTitre ? ' diag-note-titre--masque' : ''}">${note.titre}</strong><p class="diag-note-texte">${note.texte.replace(/\n/g, '</p><p class="diag-note-texte">')}</p>`
        notesListe.appendChild(li)
      })
      sectionConseils.appendChild(notesListe)
    }
  }

  // --- SECTION 4 : Routine (jaune) ---
  const sectionRoutine = document.createElement('div')
  sectionRoutine.className = 'diag-section--routine'
  const titreRoutine = document.createElement('h2')
  titreRoutine.className   = 'diag-section-titre'
  titreRoutine.textContent = 'La routine pensée pour votre peau'
  sectionRoutine.appendChild(titreRoutine)
   if (content.introRoutine) {
      const introRoutineEl = document.createElement('p')
      introRoutineEl.className   = 'diag-routine__intro'
      introRoutineEl.textContent = content.introRoutine
      sectionRoutine.appendChild(introRoutineEl)
  }

  content.recommandations
    .slice()
    .sort((a, b) => (a.order || 99) - (b.order || 99))
    .forEach(cat => {
      const section = document.createElement('div')
      section.className = 'diag-categorie'
      const titreCat = document.createElement('h3')
      titreCat.textContent = cat.label
      section.appendChild(titreCat)
      cat.produits.forEach(produit => {
        const card = document.createElement('div')
        card.className      = 'diag-produit'
        card.dataset.handle = produit.handle
        card.innerHTML = `
          <img class="diag-produit__img" src="${produit.image || ''}" alt="${produit.titre}">
          <div class="diag-produit__body">
              <p class="diag-produit__titre">${produit.titre}</p>
              <p class="diag-produit__accroche">${produit.accroche}</p>
              <p class="diag-produit__texte">${produit.texte}</p>
              ${produit.routine ? `<p class="diag-produit__routine">${produit.routine.moment}${produit.routine.frequence ? ' · ' + produit.routine.frequence : ''}</p>` : ''}
              <a class="diag-btn diag-btn--primary" href="/products/${produit.handle}">Découvrir</a>
          </div>
`
        const btn = document.createElement('button')
        btn.className   = 'diag-btn diag-btn--panier'
        btn.textContent = 'Ajouter au panier'
        btn.addEventListener('click', () => ajouterAuPanier(produit.handle, btn))
        card.querySelector('.diag-produit__body').appendChild(btn)

        section.appendChild(card)

      })
      sectionRoutine.appendChild(section)
    })
  container.appendChild(sectionRoutine)

  if (content.notes && content.notes.length > 0) {
    container.appendChild(sectionConseils)
  }

  // --- Notes après routine (toujours dans conseils bleu) ---
  if (notesApres.length > 0) {
    const notesListe = document.createElement('ul')
    notesListe.className = 'diag-notes'
    notesApres.sort((a, b) => a.titre.localeCompare(b.titre))
    notesApres.forEach((note, index) => {
      const li = document.createElement('li')
      li.className = 'diag-note'
      const memeTitre = index > 0 && notesApres[index - 1].titre === note.titre
      li.innerHTML = `<strong class="diag-note-titre${memeTitre ? ' diag-note-titre--masque' : ''}">${note.titre}</strong><p class="diag-note-texte">${note.texte.replace(/\n/g, '</p><p class="diag-note-texte">')}</p>`
      notesListe.appendChild(li)
    })
    sectionConseils.appendChild(notesListe)
  }

    // --- Articles pilier ---
  if (content.articles.pilier && content.articles.pilier.length > 0) {
    const sectionArticles = document.createElement('div')
    sectionArticles.className = 'diag-section diag-section--articles'

    const titreArticles = document.createElement('h2')
    titreArticles.className = 'diag-section-titre'
    titreArticles.textContent = 'Pour aller plus loin'

    sectionArticles.appendChild(titreArticles)

    const introArticles = document.createElement('p')
    introArticles.className = 'diag-articles__intro'
    introArticles.textContent =
     `Votre diagnostic apporte une vision globale de votre peau. Si vous souhaitez comprendre les mécanismes qui se cachent derrière les recommandations proposées, les articles ci-dessous vous permettront d'aller plus loin.`
    sectionArticles.appendChild(introArticles)

    const liste = document.createElement('div')
    liste.className = 'diag-articles'

    content.articles.pilier.forEach(article => {
      const a = document.createElement('a')
      a.className = 'diag-article'
      a.href = article.url
      a.textContent = '→ ' + article.titre
      liste.appendChild(a)
    })

    sectionArticles.appendChild(liste)
    container.appendChild(sectionArticles)
    }

  // --- Articles conditionnels ---
  if (content.articles.conditionnel && content.articles.conditionnel.length > 0) {
    const sectionCond = document.createElement('div')
    sectionCond.className = 'diag-section--articles-cond'
    const titreCond = document.createElement('h2')
    titreCond.className   = 'diag-section-titre'
    titreCond.textContent = 'Parce que vous nous avez indiqué que…'
    sectionCond.appendChild(titreCond)
    const listeCond = document.createElement('div')
    listeCond.className = 'diag-articles'
    content.articles.conditionnel.forEach(article => {
      const a = document.createElement('a')
      a.className   = 'diag-article'
      a.href        = article.url
      a.textContent = '--> ' + article.titre
      listeCond.appendChild(a)
    })
    sectionCond.appendChild(listeCond)
    container.appendChild(sectionCond)
  }
  // ------------------------------------------------------------
  // Conservation du diagnostic
  // ------------------------------------------------------------

  const sectionConservation = document.createElement('div')
  sectionConservation.className = 'diag-section--email'
  container.appendChild(sectionConservation)

  function recommencerDiagnostic() {
    const confirmation = confirm(
      'Recommencer le diagnostic depuis le début ?'
    )

    if (!confirmation) return

    sessionStorage.removeItem(DIAGNOSTIC_SESSION_KEY)

    window.__lastDiagResult = null
    window.diagPrenom = null

    DiagnosticUI.answers = {}
    DiagnosticUI.currentStep = 0
    DiagnosticUI.isSubmitting = false

    window.location.href = window.location.pathname
  }

  // ------------------------------------------------------------
  // Cliente connectée
  // ------------------------------------------------------------

  function afficherBlocCompte() {
  sectionConservation.innerHTML = `
    <h2 class="diag-section-titre">Ajouter ce diagnostic à votre espace</h2>

    <p class="diag-email__texte">
      Retrouvez ce diagnostic à tout moment dans votre espace client,
      sans avoir à refaire le questionnaire.
    </p>

    <div class="diag-email__actions">
      <button
        type="button"
        id="diag-save-btn"
        class="diag-btn diag-btn--primary"
      >
        Enregistrer dans mon espace
      </button>

      <button
        type="button"
        id="diag-restart-btn"
        class="diag-btn diag-btn--secondary"
      >
        Recommencer le diagnostic
      </button>
    </div>

    <p id="diag-save-msg" class="diag-email__msg"></p>
  `

  const saveButton =
    sectionConservation.querySelector('#diag-save-btn')

  const restartButton =
    sectionConservation.querySelector('#diag-restart-btn')

  const saveMessage =
    sectionConservation.querySelector('#diag-save-msg')

  restartButton.addEventListener(
    'click',
    recommencerDiagnostic
  )

  saveButton.addEventListener('click', async () => {
    let nomProfil =
      String(window.diagPrenom || '').trim()

    if (!nomProfil) {
      nomProfil =
        prompt('Pour quel profil ?', 'Mon profil')?.trim()
    }

    if (!nomProfil) return

    saveButton.disabled = true
    saveButton.textContent = 'Enregistrement en cours…'
    saveMessage.textContent = ''

    try {
      await window.DiagnosticAccount.ajouterOuRemplacerProfil(
        window.__lastDiagResult,
        nomProfil
      )

      saveButton.textContent = '✓ Diagnostic enregistré'
      saveButton.classList.add('diag-btn--saved')

      saveMessage.innerHTML = `
        Votre diagnostic est désormais disponible dans
        <strong>Mon compte &gt; Mes diagnostics</strong>.
      `
    } catch (error) {
      console.error(
        '[diagnostic-ui] Enregistrement impossible :',
        error
      )

      saveButton.disabled = false
      saveButton.textContent =
        'Enregistrer dans mon espace'

      saveMessage.textContent =
        'Le diagnostic n’a pas pu être enregistré. Merci de réessayer.'
    }
  })
}

  // ------------------------------------------------------------
  // Personne non connectée
  // ------------------------------------------------------------

  function afficherBlocEmail() {
    const encoded = btoa(
      unescape(
        encodeURIComponent(
          JSON.stringify(content)
        )
      )
    )

    const resultUrl =
      `${window.location.origin}/pages/diagnostic-kosmorebi?r=${encoded}`

    sectionConservation.innerHTML = `
      <h2 class="diag-section-titre">Conservez votre diagnostic</h2>

      <p class="diag-email__texte">
        Recevez une copie de vos résultats par e-mail et retrouvez-les
        facilement lors de votre prochaine visite.
      </p>

      <ul class="diag-email__benefits">
        <li>✓ Votre profil cutané personnalisé</li>
        <li>✓ Votre routine recommandée</li>
        <li>✓ Les articles adaptés à votre peau</li>
        <li>✓ Un accès à votre dernier diagnostic sans refaire le questionnaire</li>
      </ul>

      <div class="diag-email__form">
        <input
          type="email"
          id="diag-email-input"
          class="diag-email__input"
          placeholder="votre@email.com"
        >

        <button
          type="button"
          id="diag-email-btn"
          class="diag-btn diag-btn--primary"
        >
          Recevoir mon diagnostic
        </button>
      </div>

      <p id="diag-email-msg" class="diag-email__msg"></p>
    `

    const emailInput =
      sectionConservation.querySelector('#diag-email-input')

    const emailButton =
      sectionConservation.querySelector('#diag-email-btn')

    const emailMessage =
      sectionConservation.querySelector('#diag-email-msg')

    emailButton.addEventListener('click', async () => {
      const email = emailInput?.value.trim()

      if (!email || !email.includes('@')) {
        emailMessage.textContent =
          'Veuillez entrer une adresse e-mail valide.'
        emailMessage.style.color = '#a33'
        return
      }

      emailButton.disabled = true
      emailButton.textContent = 'Envoi en cours…'
      emailMessage.textContent = ''

      try {
        const response = await fetch(
          'https://api.emailjs.com/api/v1.0/email/send',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              service_id: 'service_zcnevj2',
              template_id: 'template_15g77ag',
              user_id: 'xKFiaUN-ZdRyfBjn7',
              template_params: {
                to_email: email,
                prenom: window.diagPrenom || '',
                result_url: resultUrl
              }
            })
          }
        )

        if (!response.ok) {
          throw new Error('email_send_error')
        }

        emailButton.textContent = 'Diagnostic envoyé'

        emailMessage.textContent =
          'Votre diagnostic a bien été envoyé. Pensez à vérifier vos courriers indésirables.'

        emailMessage.style.color = 'var(--kos-green)'
      } catch (error) {
        console.error(
          '[diagnostic-ui] Envoi de l’e-mail impossible :',
          error
        )

        emailButton.disabled = false
        emailButton.textContent =
          'Recevoir mon diagnostic'

        emailMessage.textContent =
          'Une erreur est survenue. Merci de réessayer.'

        emailMessage.style.color = '#a33'
      }
    })
  }

  // Le proxy permet de savoir si la cliente est connectée.
  if (window.DiagnosticAccount) {
    window.DiagnosticAccount.lireProfils()
      .then(() => {
        afficherBlocCompte()
      })
      .catch(() => {
        afficherBlocEmail()
      })
  } else {
    afficherBlocEmail()
  }

}

// ------------------------------------------------------------
// RADAR SVG
// ------------------------------------------------------------

function renderRadar(piliers) {
  const size   = 500
  const cx     = size / 2
  const cy     = size / 2
  const rMax = size / 2 - 80
  const offset = 55
  const n      = piliers.length
  const angles = piliers.map((_, i) => (Math.PI * 2 * i) / n - Math.PI / 2)

  function pt(r, a) { return [cx + r * Math.cos(a), cy + r * Math.sin(a)] }
  function poly(r)  { return angles.map(a => pt(r, a).join(',')).join(' ') }

  const svgNS = 'http://www.w3.org/2000/svg'
  const svg   = document.createElementNS(svgNS, 'svg')
  svg.setAttribute('viewBox', `0 0 ${size} ${size}`)
  svg.setAttribute('class', 'diag-radar')
  svg.setAttribute('width', '100%')
  svg.removeAttribute('height')


  ;[0.25, 0.5, 0.75, 1].forEach(t => {
    const el = document.createElementNS(svgNS, 'polygon')
    el.setAttribute('points', poly(rMax * t))
    el.setAttribute('class', 'diag-radar__grid')
    svg.appendChild(el)
  })

  angles.forEach(a => {
    const [x, y] = pt(rMax, a)
    const line   = document.createElementNS(svgNS, 'line')
    line.setAttribute('x1', cx) ; line.setAttribute('y1', cy)
    line.setAttribute('x2', x)  ; line.setAttribute('y2', y)
    line.setAttribute('class', 'diag-radar__axis')
    svg.appendChild(line)
  })

  const dataPoints = angles.map((a, i) => pt(rMax * (piliers[i].score / 10), a).join(',')).join(' ')
  const dataPoly   = document.createElementNS(svgNS, 'polygon')
  dataPoly.setAttribute('points', dataPoints)
  dataPoly.setAttribute('class', 'diag-radar__data')
  svg.appendChild(dataPoly)

  angles.forEach((a, i) => {
    const [x, y] = pt(rMax * (piliers[i].score / 10), a)
    const circle = document.createElementNS(svgNS, 'circle')
    circle.setAttribute('cx', x) ; circle.setAttribute('cy', y)
    circle.setAttribute('r', 3)  ; circle.setAttribute('class', 'diag-radar__dot')
    svg.appendChild(circle)
  })

  angles.forEach((a, i) => {
    const [x, y] = pt(rMax + offset, a)
    const lbl = document.createElementNS(svgNS, 'text')
    lbl.setAttribute('x', x)
    lbl.setAttribute('y', y - 5)
    lbl.setAttribute('text-anchor', 'middle')
    lbl.setAttribute('font-size', '26')
    lbl.setAttribute('class', 'diag-radar__label')
    lbl.textContent = piliers[i].label
    svg.appendChild(lbl)

    const sc = document.createElementNS(svgNS, 'text')
    sc.setAttribute('x', x)
    sc.setAttribute('y', y + 10)
    sc.setAttribute('text-anchor', 'middle')
    sc.setAttribute('font-size', '14')
    sc.setAttribute('class', 'diag-radar__score-txt')
    sc.textContent = `${piliers[i].score}`
    svg.appendChild(sc)
  })

  const wrapper = document.createElement('div')
  wrapper.className = 'diag-radar-wrapper'
  wrapper.appendChild(svg)
  return wrapper
}

// ------------------------------------------------------------
// CHARGEMENT IMAGES PRODUITS
// ------------------------------------------------------------

function loadProductImages() {
  document.querySelectorAll('.diag-produit[data-handle]').forEach(card => {
    const handle = card.dataset.handle
    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(data => {
        const img = card.querySelector('.diag-produit__img')
        if (img && data.featured_image) img.src = data.featured_image.src || data.featured_image
      })
      .catch(() => {})
  })
}

async function ajouterAuPanier(handle, btn) {
  btn.disabled = true
  btn.textContent = 'Ajout…'

  try {
    let variantId = _variantCache[handle]?.id
    if (!variantId) {
      const data = await fetch(`/products/${handle}.js`).then(r => r.json())
      const v = data.variants?.find(v => v.available) || data.variants?.[0]
      if (!v) throw new Error('Aucune variante')
      _variantCache[handle] = { id: v.id, available: v.available }
      variantId = v.id
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    if (!res.ok) throw new Error()

    btn.textContent = '✓ Ajouté'
    btn.classList.add('diag-btn--panier-ok')

  } catch {
    btn.textContent = 'Erreur — réessayer'
    btn.disabled = false
  }
}


// ------------------------------------------------------------
// UTILITAIRES
// ------------------------------------------------------------

function getSelectedAnswers(questionId) {
  const val = DiagnosticUI.answers[questionId]
  if (!val) return []
  return Array.isArray(val) ? val : [val]
}

function showError(message) {
  const existing = DiagnosticUI.container?.querySelector('.diag-error')
  if (existing) existing.remove()
  const el = document.createElement('p')
  el.className   = 'diag-error'
  el.textContent = message
  DiagnosticUI.container?.appendChild(el)
}

window.initDiagnostic = initDiagnostic

window.addEventListener('pageshow', event => {
  const navigation = performance.getEntriesByType('navigation')[0]

  const retourArriere =
    event.persisted ||
    navigation?.type === 'back_forward'

  if (!retourArriere) return

  const container = DiagnosticUI?.container

  if (!container) return

  // Si la page restaurée par le navigateur contient déjà les résultats,
  // on ne la reconstruit pas une seconde fois.
  if (container.querySelector('.diag-intro')) return

  restaurerDiagnosticEnCours()
})

